// extracted by mini-css-extract-plugin
export default {"starLayer":"StarLayer_starLayer__w5rII"};